(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _tippy = _interopRequireDefault(require("tippy.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// tooltip init
(0, _tippy["default"])('[data-tippy-content]');
(0, _tippy["default"])('.tip-content', {
  content: function content(reference) {
    var id = reference.getAttribute('data-template');
    var template = document.getElementById(id);
    return template.innerHTML;
  },
  allowHTML: true,
  trigger: 'click',
  theme: 'light-border',
  interactive: true
});

},{"tippy.js":"tippy.js"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toTitleCase = toTitleCase;
// Portal Javascript
// Requires jQuery!
jQuery.ajax({
  url: "https://ardc.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/tod1zk/b/9/b0105d975e9e59f24a3230a22972a71a/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-GB&collectorId=427fb7ef",
  type: "get",
  cache: true,
  dataType: "script"
});
window.ATL_JQ_PAGE_PROPS = {
  "triggerFunction": function triggerFunction(showCollectorDialog) {
    //Requires that jQuery is available!
    jQuery(".feedback_button").on('click', function (e) {
      e.preventDefault();
      showCollectorDialog();
    });
  }
};
function changePlaceholderText(selectedOption) {
  selectedOption = selectedOption.trim(); // Remove any whitespace
  switch (selectedOption) {
    case "Researcher":
      $("#search").attr('placeholder', "Search by researcher's name or research expertise");
      break;
    case "Organisation":
      $("#search").attr('placeholder', "Search by organisation name or its focus area");
      break;
    case "Funded Activity":
      $("#search").attr('placeholder', "Search by title, funding provider, or keywords");
      break;
    default:
      $("#search").attr('placeholder', "Search for research and linkages");
  }
}
function showTargetSearchFields() {
  var target = $('#target').val();
  var targetElement = $('#search-advanced-selector_' + target);
  $("div[id*='search-advanced-selector_']:not(.d-none)").addClass("d-none");
  targetElement.removeClass("d-none");
}
function capitaliseWords(inputString) {
  // Split the string into words
  var words = inputString.toLowerCase().split(' ');

  // Capitalize the first letter of each word
  for (var i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].substring(1);
  }

  // Join the words back together
  return words.join(' ');
}

// Document Ready
$(function () {
  // Add slideDown animation to Bootstrap nav dropdown when expanding.
  $('#nav-portal .dropdown').on('show.bs.dropdown', function () {
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown('fast');
  });

  // Add slideUp animation to Bootstrap nav dropdown when collapsing.
  $('#nav-portal .dropdown').on('hide.bs.dropdown', function () {
    $(this).find('.dropdown-menu').first().stop(true, true).slideUp('fast');
  });

  // Enable Bootstrap 5 tooltips
  $('[data-bs-toggle="tooltip"]').each(function (index) {
    return new bootstrap.Tooltip($(this));
  });

  // Enable Bootstrap 5 popovers
  $('[data-bs-toggle="popover"]').each(function (index) {
    return new bootstrap.Popover($(this));
  });

  // Show back to top button if scrolled past 100px
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 100) {
      $('#back-to-top').fadeIn();
    } else {
      $('#back-to-top').fadeOut();
    }
  });

  // Scroll body to 0px on click
  $('#back-to-top').on('click', function () {
    $('body,html').animate({
      scrollTop: 0
    }, 400);
    return false;
  });
  $(".quick-search").on('click', function () {
    $("#search").text($(this).text());
  });

  // JavaScript code to handle icon click event
  $('#advancedSearchButton').on('click', function () {
    showTargetSearchFields();
    $('#advancedSearchModal').modal('show');
  });

  // JavaScript code to handle form submission
  $('#searchButton').on('click', function () {
    //Retrieve form data and perform Elasticsearch search
    var target = document.getElementById('target').value;
    console.log('Clicked on Search button' + target);
    var divNode = document.getElementById('search-advanced-selector_' + target);
    var inputNodes = divNode.querySelectorAll('input, select');
    var aq = '';
    // inputNode.name is research-topic, title, identifier , inputNode.value is what we type
    var first = true;
    inputNodes.forEach(function (inputNode) {
      if (inputNode.type === 'text' && inputNode.value !== '') {
        if (first) {
          aq = aq + inputNode.name + ':' + inputNode.value;
          first = false;
        } else {
          aq = aq + ',' + inputNode.name + ':' + inputNode.value;
        }
      } else if (inputNode.tagName.toLowerCase() === 'select') {
        var selectedOption = inputNode.options[inputNode.selectedIndex].value;
        //console.log('Clicked on Selected Option -->' + selectedOption);
        if (first) {
          aq = aq + inputNode.name + ':' + selectedOption;
          first = false;
        } else {
          aq = aq + ',' + inputNode.name + ':' + selectedOption;
        }
      }
    });
    console.log("&aq=" + aq);
    document.getElementById('advance-search').value = aq;
    document.getElementById('submitBtn').click();
  });
  $('#banner-search-nav .nav-link').on('click', function (e) {
    e.preventDefault(); // Stops the link adding # to url
    var value = $(this).attr('data-value');
    var title = $(this).attr('data-title');
    // $('#selected-option').text(title);
    $('#banner-search-nav .nav-link.active').removeClass("active");
    $(this).addClass("active");
    changePlaceholderText(title);
    $('#target').val(value);
    showTargetSearchFields();
  });
  $('.search-dropdown').on('click', function (e) {
    e.preventDefault(); // Stops the link adding # to url
    var value = $(this).attr('data-value');
    var title = $(this).attr('data-title');
    $('#selected-option').text(title);
    changePlaceholderText(title);
    $('#target').val(value);
    showTargetSearchFields();
  });
});
function toTitleCase(label) {
  if (!label) return '';
  var lowerWords = new Set(['and', 'or', 'the', 'of', 'in', 'on', 'at', 'to', 'a', 'an', 'for']);
  var knownAcronyms = new Map([['nhmrc', 'NHMRC'], ['arc', 'ARC'], ['csiro', 'CSIRO']]);
  function isAcronym(token) {
    var core = token.replace(/[^A-Za-z]/g, '');
    return core.length >= 2 && core === core.toUpperCase();
  }
  function isMixedCase(seg) {
    // preserve any natural camelCase/mixedCase segment
    return /[A-Z].*[a-z]|[a-z].*[A-Z]/.test(seg);
  }
  var words = label.split(/\s+/);
  return words.map(function (rawWord, index, arr) {
    var prev = index > 0 ? arr[index - 1] : '';
    var prevEndsWithOpenBracket = /[\(\[\{“"']$/.test(prev);

    // split into leading punctuation + rest
    var match = rawWord.match(/^([^A-Za-zÀ-ÖØ-öø-ÿ]*)(.*)$/);
    var leading = match[1];
    var rest = match[2];
    var segIndex = 0;
    var processed = rest.replace(/(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])+/g, function (segment) {
      var lowerSeg = segment.toLowerCase();

      // 1) Known acronyms (CSIRO, ARC…)
      if (knownAcronyms.has(lowerSeg)) {
        return knownAcronyms.get(lowerSeg);
      }

      // 2) Detect natural mixedCase (AgResearch, eResearch, BioTech…)
      if (isMixedCase(segment)) {
        return segment; // leave exactly as-is
      }

      // 3) Uppercase acronyms (already all caps)
      if (isAcronym(segment)) {
        return segment.toUpperCase();
      }

      // 4) Normal title-case rules
      var isFirstWord = index === 0 && segIndex === 0;
      var isSmallWord = lowerWords.has(lowerSeg);
      var shouldCapitalize = isFirstWord || prevEndsWithOpenBracket || !isSmallWord;
      segIndex++;
      if (!shouldCapitalize) {
        return segment.toLowerCase();
      }
      return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
    });
    return leading + processed;
  }).join(' ');
}
window.toTitleCase = toTitleCase;
document.addEventListener("DOMContentLoaded", function () {
  // Get the dropdown menu element
  var dropdownMenu = document.querySelector('.dropdown-menu.dashboard-selector');
  if (dropdownMenu != null) {
    // Function to set iframe src and clear filters
    var setIframeSrcAndClearFilters = function setIframeSrcAndClearFilters(selectedId) {
      // Check if selectedId is valid
      if (selectedId) {
        // Clear filters by modifying the URL
        var clearedUrl = clearFilters(selectedId);
        iframe.src = clearedUrl;
      } else {
        console.error("Invalid selectedId:", selectedId);
      }
    };
    var clearFilters = function clearFilters(url) {
      // Check if URL already contains query parameters
      if (url.indexOf('?') !== -1) {
        // Append '&' if query parameters already exist
        return url + '&_g=(filters:!())';
      } else {
        // Append '?' if no query parameters exist
        return url + '?_g=(filters:!())';
      }
    }; // Set initial iframe src and clear filters
    // Get all dropdown items within the dropdown menu
    var dropdownItems = dropdownMenu.querySelectorAll('.dropdown-item-db');

    // Get the dropdown button element
    var dropdownButton = document.getElementById("dbdropdownMenuButton");

    // Get the iframe element
    var iframe = document.getElementById("dashboard-iframe");
    setIframeSrcAndClearFilters(dropdownItems[0].getAttribute('data-value'));

    // Add the 'selected' attribute to the first dropdown item
    dropdownItems[0].setAttribute('selected', 'selected');

    // Set the dropdown button text to the text of the selected option
    dropdownButton.textContent = dropdownItems[0].textContent;
    // Add event listener to each dropdown item
    dropdownItems.forEach(function (item) {
      item.addEventListener("click", function () {
        // Get selected option value
        var selectedId = this.getAttribute('data-value');
        // Set iframe src and clear filters
        setIframeSrcAndClearFilters(selectedId);
        document.querySelector('#dbdropdownMenuButton').textContent = this.getAttribute('data-title');
      });
    });
  }
  function createBarChart() {
    if (typeof vocabData != 'undefined') {
      // Filter out null or undefined labels
      var filteredData = vocabData.filter(function (d) {
        return d.label != null;
      });

      // Take top 5
      var topData = filteredData.length > 5 ? filteredData.slice(0, 5) : filteredData;

      // Apply title casing to display labels
      topData.forEach(function (d) {
        d.displayLabel = toTitleCase(d.label);
      });

      // Set up chart dimensions
      var margin = {
        top: 20,
        right: 20,
        bottom: 30,
        left: 40
      };
      var containerWidth = document.getElementById('bar-chart-container').offsetWidth;
      var containerHeight = 300;
      var width = containerWidth - margin.left - margin.right;
      var height = containerHeight - margin.top - margin.bottom;

      // Remove any existing SVG
      d3.select("#bar-chart-container svg").remove();

      // Define scales
      var xScale = d3.scaleLinear().domain([0, d3.max(topData, function (d) {
        return d.count;
      })]).range([0, width]);

      // Use a unique key for the y-scale domain to prevent overwriting
      var yScale = d3.scaleBand().domain(topData.map(function (d) {
        return "".concat(d.type || '', "-").concat(d.version || '', "-").concat(d.label);
      })).range([0, height]).padding(0.1);

      // Create the SVG container
      var svg = d3.select("#bar-chart-container").append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(".concat(margin.left, ",").concat(margin.top, ")"));

      // Color scale for fading purple color
      var colorScale = d3.scaleLinear().domain([d3.max(topData, function (d) {
        return d.count;
      }), 0]).range(["#8E489B", "#f8b20e"]);

      // Draw bars
      svg.selectAll(".bar").data(topData).enter().append("rect").attr("class", "bar").attr("width", function (d) {
        return xScale(d.count);
      }).attr("height", yScale.bandwidth()).attr("y", function (d) {
        return yScale("".concat(d.type || '', "-").concat(d.version || '', "-").concat(d.label));
      }).attr("fill", function (d) {
        return colorScale(d.count);
      });

      // Add text labels inside bars (title-cased labels)
      svg.selectAll(".label").data(topData).enter().append("text").attr("class", "label").attr("x", 5).attr("y", function (d) {
        return yScale("".concat(d.type || '', "-").concat(d.version || '', "-").concat(d.label)) + yScale.bandwidth() / 2;
      }).attr("dy", "0.35em").attr("text-anchor", "start").attr("fill", "white").text(function (d) {
        return d.displayLabel;
      });

      // Add count labels on the right end of each bar
      svg.selectAll(".count-label").data(topData).enter().append("text").attr("class", "count-label").attr("x", function (d) {
        return xScale(d.count) - 5;
      }).attr("y", function (d) {
        return yScale("".concat(d.type || '', "-").concat(d.version || '', "-").concat(d.label)) + yScale.bandwidth() / 2;
      }).attr("dy", "0.35em").attr("text-anchor", "end").attr("fill", "white").text(function (d) {
        return "(".concat(d.count, ")");
      });
    }
  }
  var pageSizeSelects = document.querySelectorAll('.page-size-select');
  pageSizeSelects.forEach(function (pageSizeSelect) {
    pageSizeSelect.addEventListener('change', function () {
      var currentUrl = new URL(window.location.href);
      var params = currentUrl.searchParams;
      params.set('size', this.value);
      params.set('page', '0');
      window.location.href = currentUrl.toString();
    });
  });

  // Call the createBarChart function initially
  createBarChart();

  // Function to handle resizing of the window
  function rescale() {
    // Call the createBarChart function to redraw the chart
    createBarChart();
  }

  // Listen for window resize events
  window.addEventListener("resize", rescale);

  // Select all FOR subject labels inside the researcher summary
  document.querySelectorAll('[th\\:each] a span, .tclabel').forEach(function (span) {
    var text = span.textContent.trim();
    span.textContent = toTitleCase(text);
  });
});

},{}]},{},[1,2]);
